import logger from 'logger';
import NotificationService from 'services/NotificationService';
import ApiException from 'services/ApiService/ApiException';
import httpStatusCodes from 'enum/httpStatusCodes';


type ErrorStatus = {
  status: number;
  statusText: string;
};

const notify = (
  { status, statusText }: ErrorStatus,
  force: boolean,
  showAxiosErrorMessage: boolean,
  showToastMsg: boolean
): void => {
  if (!showToastMsg) {
    return;
  }

  let message = undefined;

  if (typeof httpStatusCodes[status] === 'string') {
    message = httpStatusCodes[status];
  }

  if (force) {
    message = httpStatusCodes['500'];
  }

  if (showAxiosErrorMessage) {
    message = statusText;
  }

  if (force && showAxiosErrorMessage) {
    message = statusText;
  }

  if (message) {
    NotificationService.create({
      type: NotificationService.type.TOAST,
      subtype: NotificationService.subtype.ERROR,
      text: message,
    });
  }
};

const parseCatch = (
  apiError: ApiException,
  force = false,
  showAxiosErrorMessage = false,
  showToastMsg = false
) => {
  const { response } = apiError;
  // APIs that are not Restful will not throw an error this is why the next line is here
  logger.error({ msg: 'API_ERROR', error: response });
  if (response && response.status) {
    notify(response, force, showAxiosErrorMessage, showToastMsg);
  }
};

export default parseCatch;
